class QuickBuy extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['submit', 'submit-text']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this?.els?.select?.exists) return

    this.onVariantChange = this.onVariantChange.bind(this)

    this.listeners.add(this.els.select.element, 'change', this.onVariantChange)
  }

  onVariantChange (e) {
    this.setAvailability(e)
  }

  setAvailability (e) {
    const selectedOption = e?.target.options[e?.target.selectedIndex]
    const isAvailable =
      selectedOption?.getAttribute('data-available') === 'true'
    const addToCartLabel = window.theme.strings.addToCart

    this.els.submit.element.disabled = !isAvailable

    this.els['submit-text'].element.textContent = isAvailable
      ? addToCartLabel
      : window.theme.strings.soldOut
  }
}

if (!customElements.get('quick-buy')) {
  customElements.define('quick-buy', QuickBuy)
}
